import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=4af0b746&scoped=true&"
import script from "./Prizes.vue?vue&type=script&lang=js&"
export * from "./Prizes.vue?vue&type=script&lang=js&"
import style0 from "./Prizes.vue?vue&type=style&index=0&id=4af0b746&prod&lang=scss&scoped=true&"
import style1 from "./Prizes.vue?vue&type=style&index=1&id=4af0b746&prod&lang=scss&scoped=true&"
import style2 from "./Prizes.vue?vue&type=style&index=2&id=4af0b746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0b746",
  null
  
)

export default component.exports